<template>
  <div class="container_brand" style="overflow-y: hidden">
    <HomeHead></HomeHead>
    <iframe style="width: 100%; height: 100%" :src="url">
      此浏览器不支持该用户手册格式。请下载以查看：
      <a :href="url">下载用户手册</a>
    </iframe>
    <!-- <el-image
      :src="require('../../assets/images/brand/Course.jpg')"
      fit="fill"
    ></el-image> -->
    <!-- <el-row>
      <el-col :md="{ span: 20, offset: 2 }">
        <div class="anchor_map">
          <span>快速导航：</span>
          <el-link type="primary" @click="goAnchor('#CreateMetting')">
            创建会议
          </el-link>
          <el-link type="primary" @click="goAnchor('#JoinMetting')">
            进入会议
          </el-link>
          <el-link type="primary" @click="goAnchor('#CreateVote')">
            创建投票
          </el-link>
          <el-link type="primary" @click="goAnchor('#voteBasic')">
            投票基本信息
          </el-link>
          <el-link type="primary" @click="goAnchor('#voteUser')">
            投票投票人员
          </el-link>
          <el-link type="primary" @click="goAnchor('#voteProject')">
            投票待评项目
          </el-link>
          <el-link type="primary" @click="goAnchor('#startVote')">
            开启投票
          </el-link>
        </div>
        <br>
        <el-link type="primary" target="_blank" href="#/manua">下载文档</el-link>
        <h1><span id="CreateMetting" name="CreateMetting">创建会议</span></h1>
        <p>登录成功后，如果是第一次访问，点击【创建会议】按钮创建会议。</p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/createMeeting.png')"
            fit="fill"
          ></el-image>
        </p>
        <p>弹出创建会议信息页面，填写会议信息</p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="
              require('../../assets/images/brand/course/createMeeting1.png')
            "
            fit="fill"
          ></el-image>
        </p>
        <h1><span id="JoinMetting" name="JoinMetting">进入会议</span></h1>
        <p>
          选择会议列表页面上的某个会议，点击对应的"进入会议"按钮，进入投票列表。
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/mettingList.png')"
            fit="fill"
          ></el-image>
        </p>
        <h1><span id="CreateVote" name="CreateVote">创建投票</span></h1>
        <p>
          选择会议列表上的某个会议，点击【进入会议】按，进入会议后打开新增投票页面，创建投票。
        </p>
        <h2><span id="voteBasic" name="voteBasic">第一步：基本信息</span></h2>
        <p>
          企业投票云服务目前提供4种投票方式：入围、排序、打分、投屏，针对不同场景、不同投票方式。
        </p>
        <h3>入围投票</h3>
        <p>
          奖项评选、职称评审、资格评审、技术评审、表决法案、专家评选、初赛预选
        </p>
        <p>
          需要填写的信息：<br />
          <ul>
          <li>投票名称，必填 投票方式选择入围方式，必选</li>
          <li>规则名称，必填，直接输入规则名称或者选择已有规则</li>
          <li>通过方式，必填，选择通过方式并且指定通过比列</li>
          <li>点击【保存】按钮保存已填写基本信息</li>
          <li>点击【下一步】按钮保存已填写基本信息并且进入创建投票第二步，选择“投票人员”</li>
          </ul>
        </p>
                <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/ruwei_basic.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>排序投票</h3>
        <p>
          小组排名、奖项排名
        </p>
        <p>
           排序投票不需要定义规则，需要填写的信息：<br />
          <ul>
          <li>投票名称，必填</li>
          <li>投票方式选择排序方式，必选</li>
          <li>点击【保存】按钮保存已填写基本信息</li>
          <li>点击【下一步】按钮保存已填写基本信息并且进入创建投票第二步，选择“投票人员”</li>
          </ul>
        </p>
                <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/paixu_basic.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>打分投票</h3>
        <p>
          比赛打分、竞选评分
        </p>
        <p>
           需要填写的信息：<br />
          <ul>
          <li>投票名称，必填</li>
          <li>投票方式选择打分方式，必选</li>
          <li>规则名称，必填，直接输入规则名称或者选择已有规则</li>
          <li>去掉最高分</li>
          <li>去掉最低分</li>
          <li>细则，至少需要一项细则</li>
          <li>点击【保存】按钮保存已填写基本信息</li>
          <li>点击【下一步】按钮保存已填写基本信息并且进入创建投票第二步，选择“投票人员”</li>
          </ul>
        </p>
                <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/dafen_basic.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>投屏投票</h3>
        <p>
          现场评分、现场比赛、现场竞选
        </p>
        <p>
           需要填写的信息：<br />
          <ul>
          <li>投票名称，必填</li>
          <li>投票方式选择投屏方式，必选</li>
          <li>规则名称，必填，直接输入规则名称或者选择已有规则</li>
          <li>显示评委信息，控制大屏幕上是否显示评委照片等信息</li>
          <li>去掉最高分</li>
          <li>去掉最低分</li>
          <li>最低分数，投票人打分时最低分数限制</li>
          <li>最高分数，投票人打分时最高分数限制</li>
          <li>点击【保存】按钮保存已填写基本信息</li>
          <li>点击【下一步】按钮保存已填写基本信息并且进入创建投票第二步，选择“投票人员”</li>
          </ul>
        </p>
                <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/toupin_basic.png')"
            fit="fill"
          ></el-image>
        </p>
        <h2><span id="voteUser" name="voteUser">第二步：投票人员</span></h2>
        <h3>新增人员组</h3>
        <p>
            初始化“默认组”如图，一场会议如需多个人员分组可以自行创建，点击【新增组】填写组名称创建新的人员分组；
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteUser1.png')"
            fit="fill"
          ></el-image>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteUser2.png')"
            fit="fill"
          ></el-image>
        </p>
        <p>
            点击人员组，可以切换选中的人员分组，列表对应展示选中分组的人员信息。
        </p>
        <h3>新增人员</h3>
        <p>
            选中人员组，点击【新增人员】按钮，在该组下添加投票人员
            <ul>
                <li>姓名，必填，投票人员显示名称</li>
                <li>用户名，必填，投票人员投票登录账号</li>
                <li>密码，必填，投票人员投票登录密码</li>
                <li>显示顺序，投票人员列表中显示顺序，可以为空</li>
                <li>高级配置-权重，必填，默认投票人员权重为1，可以对人员设置特定权重</li>
                <li>高级配置-用户头像，可以上传用户头像用于投票显示</li>
                <li>点击【取消】按钮，取消新增人员</li>
                <li>点击【确定】按钮，保存新增人员信息</li>
            </ul>
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteUser3.png')"
            fit="fill"
          ></el-image>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteUser4.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>新增主持人（投屏方式）</h3>
        <p>
            选中人员组，点击【新增主持人】按钮，在该组下添加投票主持人
            <ul>
                <li>姓名，必填，投票人员显示名称</li>
                <li>用户名，必填，投票人员投票登录账号</li>
                <li>密码，必填，投票人员投票登录密码</li>
                <li>点击【取消】按钮，取消新增主持人</li>
                <li>点击【确定】按钮，保存新增主持人信息</li>
            </ul>
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteUser5.png')"
            fit="fill"
          ></el-image>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteUser6.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>导出模板</h3>
        <p>
            点击【导出模板】按钮，导出投票人员数据模板，若该组下有投票人员，一并导出
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteUser7.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>批量导入</h3>
        <p>
            选中人员组，点击【批量导入】按钮，在该组下导入投票人员
             <ul>
                <li>人员分组，指定导入的人员分组，默认为当前分组</li>
                <li>选择文件，选择本地导入的文件，需按照导出模板格式填写</li>
                <li>点击【取消】按钮，取消导入人员</li>
                <li>点击【确定】按钮，导入选择excel表格中的人员信息</li>
            </ul>
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteUser8.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>选择投票人员</h3>
        <p>
             <ul>
                <li>选择需要参与投票的人员</li>
                <li>点击【保存】按钮保存已选参投人员信息</li>
                <li>点击【下一步】按钮保存已选参投人员信息并且进入创建投票第三步，选择“待评项目”</li>
            </ul>
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteUser9.png')"
            fit="fill"
          ></el-image>
        </p>
        <h2><span id="voteProject" name="voteProject">第三步：待评项目</span></h2>
        <h3>新增项目组</h3>
        <p>
            初始化“默认组”如图，如需多个项目分组可以自行创建，点击【新增组】填写组名称创建新的项目分组；
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteProject1.png')"
            fit="fill"
          ></el-image>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteProject2.png')"
            fit="fill"
          ></el-image>
        </p>
        <p>
            点击项目组，可以切换选中的待评项目分组，待评项目分组可以同时选择多个，列表对应展示选中分组的待评项目信息。
        </p>
        <h3>新增待评项目</h3>
        <p>
            选中项目组，点击【新增项目】按钮，在该组下添加待评项目
            <ul>
                <li>项目名称，必填</li>
                <li>单位名称，必填</li>
                <li>推荐信息，可空</li>
                <li>显示顺序，待评项目列表中显示顺序，可空</li>
                <li>高级配置-基础分数，可空</li>
                <li>点击【取消】按钮，取消新增项目</li>
                <li>点击【确定】按钮，保存新增项目信息</li>
            </ul>
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteProject3.png')"
            fit="fill"
          ></el-image>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteProject4.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>导出模板</h3>
        <p>
            点击【导出模板】按钮，导出待评项目数据模板，若该组下有待评项目，一并导出
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteProject5.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>批量导入</h3>
        <p>
            选中项目组，点击【批量导入】按钮，在该组下导入待评项目
             <ul>
                <li>待评项分组，指定导入的项目分组，默认为当前分组</li>
                <li>选择文件，选择本地导入的文件，需按照导出模板格式填写</li>
                <li>点击【取消】按钮，取消导入待评项目</li>
                <li>点击【确定】按钮，导入选择excel表格中的项目信息</li>
            </ul>
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteProject6.png')"
            fit="fill"
          ></el-image>
        </p>
        <h3>选择待评项目</h3>
        <p>
             <ul>
                <li>选择需要参与投票的待评项目</li>
                <li>点击【保存】按钮保存已选待评项目信息</li>
            </ul>
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/voteProject7.png')"
            fit="fill"
          ></el-image>
        </p>
        <h2><span id="startVote" name="startVote">启动：开始投票</span></h2>
        <p>
            基本信息、投票人员、待评项目信息全部完善后，【开始投票】按钮启用，点击启动投票。
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/startVote1.png')"
            fit="fill"
          ></el-image>
        </p>
        <p>
            也可以在投票列表开始对应的投票
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/startVote2.png')"
            fit="fill"
          ></el-image>
        </p>
        <p>
            点击左侧二维码可扫码投票
        </p>
        <p>
          <el-image
            style="width: 100%; height: 100%"
            :src="require('../../assets/images/brand/course/startVote3.png')"
            fit="fill"
          ></el-image>
        </p>
      </el-col>
    </el-row> -->
    <HomeFooter></HomeFooter>
  </div>
</template>
<script>
import HomeHead from '@/components/HomeHead.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  components: {
    HomeHead,
    HomeFooter
  },
  data () {
    return {
      url: process.env.BASE_URL + 'pdf/用户手册.pdf',
      numPages: null // pdf 总页数
    }
  },
  methods: {
    goAnchor: function (type) {
      const anchor = this.$el.querySelector(type)
      document.getElementById('brand_main').scrollTop = anchor.offsetTop - 120
    }
  }
}
</script>
<style lang="less">
.anchor_map span {
  margin-right: 10px;
}
.anchor_map a {
  margin-right: 20px;
}
</style>
